export const refreshPage = 'reload-page';

export const startKey = 'start-subterfuge';
export const storageCloseKey = 'subterfuge-close';
export const storageShowDialog = 'show-dialog';

export const triggerGlobalPageReset = () => {
    localStorage.setItem(refreshPage, 'reload-page-' + Date.now());
};
